// Replace this page with another site's URL; the current history entry goes with it, so Back
// does not return to a page that already did its one-shot work (the MCP sign-in handoff).
// Its own module so tests can mock it: jsdom cannot navigate.
export function leaveDashboardFor(url) {
    window.location.replace(url);
}

// Open another company's dashboard in this tab, keeping this page in the history: Back returns here, with the
// sign-in request still stashed (the MCP handoff's franchise path, after a mistyped company code).
export function openDashboardAt(url) {
    window.location.assign(url);
}
